import { colors } from '../../../../../Services/schedule';
import { getRankChartPrintLayout, RANK_CHART_PRINT_LAYOUTS } from './rankChartPrintLayout';

export const PRINT_CANDIDATES_PER_PAGE = 10;
export const PRINT_LEGEND_ITEMS_PER_ROW = RANK_CHART_PRINT_LAYOUTS.landscape.legendItemsPerRow;
export const PRINT_BASE_CANDIDATES_PER_PAGE = RANK_CHART_PRINT_LAYOUTS.landscape.candidatesPerPageBase;
export const MIN_PRINT_CANDIDATES_PER_PAGE = 1;

export const getPrintCandidatesPerPage = (weightCount = 0, layoutId, paperId) => {
  const printLayout = getRankChartPrintLayout(layoutId, paperId);
  const legendRows = Math.ceil(weightCount / printLayout.legendItemsPerRow);
  return Math.max(MIN_PRINT_CANDIDATES_PER_PAGE, printLayout.candidatesPerPageBase - legendRows);
};

export const getPrintChartTotal = (row = {}, keys = []) => {
  return keys.reduce((total, key) => total + Number(row[key.label] || 0), 0);
};

export const formatPrintChartContribution = (value) => {
  return Number(value || 0).toFixed(2);
};

export const buildPrintChartData = (rawData = [], weights = [], mode, selectedWeightIds = null) => {
  const keys = weights
    .filter((weight) => weight.QuestionType === 'scale')
    .map((weight, index) => ({
      color: colors[index % colors.length],
      label: weight.CategoryName,
      percentage: mode === 1 ? weight.EvaluationWeight || 0 : weight.PrescreenWeight || 0,
      pk_EvaluationQuestionWeight: weight.pk_EvaluationQuestionWeight,
    }));

  const duplicateNames = {};
  const rows = rawData.map((candidate) => {
    const baseName = `${candidate.LastName ? `${candidate.LastName},` : ''} ${candidate.FirstName || ''}`.trim();
    const duplicateCount = duplicateNames[baseName] || 0;
    duplicateNames[baseName] = duplicateCount + 1;
    const row = { displayName: duplicateCount > 0 ? `${baseName} ${duplicateCount + 1}` : baseName };
    const averages = candidate.CandidateGroupAverages || {};

    keys.forEach((key) => {
      const average = averages[key.pk_EvaluationQuestionWeight];
      if (average) {
        row[key.label] = Number(average.GroupAverageAsDecimal * average.Weight);
      }
    });

    return row;
  });

  const selectedWeightIdSet = selectedWeightIds === null ? null : new Set(selectedWeightIds.map((weightId) => `${weightId}`));
  const activeKeys = keys.filter((key) => {
    return (
      key.percentage > 0 &&
      (selectedWeightIdSet === null || selectedWeightIdSet.has(`${key.pk_EvaluationQuestionWeight}`))
    );
  });
  rows.sort((a, b) => {
    const totalA = getPrintChartTotal(a, activeKeys);
    const totalB = getPrintChartTotal(b, activeKeys);
    return totalB - totalA;
  });

  return { activeKeys, rows };
};

export const splitPrintChartPages = (rows = [], candidatesPerPage = PRINT_CANDIDATES_PER_PAGE) => {
  const pages = [];
  for (let index = 0; index < rows.length; index += candidatesPerPage) {
    pages.push(rows.slice(index, index + candidatesPerPage));
  }
  return pages.length > 0 ? pages : [[]];
};

// Nivo draws the first horizontal-bar row at the bottom of the chart.
export const getPrintChartDisplayRows = (rows = []) => {
  return [...rows].reverse();
};
